import React from "react";
import { Row, Col, Typography, Form, Input, Button } from "antd";
import {
  EnvironmentOutlined,
  PhoneOutlined,
  MailOutlined,
} from "@ant-design/icons";
import { PageFade } from "../components/PageTransition";
import { Helmet } from "react-helmet";

const { Title } = Typography;
const { TextArea } = Input;

const Contact = () => {
  // Shared style for links to remove default blue underline
  const linkStyle = {
    color: "inherit",
    textDecoration: "none",
    transition: "color 0.3s",
    cursor: "pointer",
  };

  return (
    <PageFade>
      <Helmet>
        <title>Contact Us - Reservations & Inquiries | Miran Suites</title>
        <meta
          name="description"
          content="Reach out to Miran Suites for reservations and inquiries. Located at 123 Luxury Avenue. Call +1 (555) 123-4567 or email info@miransuites.com."
        />
        <meta property="og:title" content="Contact Miran Suites" />
        <meta
          property="og:description"
          content="We are here to help. Get directions, phone numbers, and email support for your next stay."
        />
      </Helmet>
      
      <div style={{ padding: "8rem 10% 4rem" }}>
        <Title
          level={1}
          style={{
            textAlign: "center",
            fontFamily: "Playfair Display",
            marginBottom: "4rem",
          }}
        >
          Contact Us
        </Title>

        <Row gutter={[64, 64]}>
          <Col xs={24} md={12}>
            <Title level={3}>Get in Touch</Title>
            
            <div style={{ fontSize: "1.1rem", lineHeight: "2.5" }}>
              {/* Address Link */}
              <p>
                <EnvironmentOutlined />{" "}
                <a 
                  href="https://maps.app.goo.gl/aC3x7g441oTX6nxe9" 
                  target="_blank" 
                  rel="noreferrer"
                  style={linkStyle}
                  onMouseOver={(e) => e.target.style.color = "#d4af37"}
                  onMouseOut={(e) => e.target.style.color = "inherit"}
                >
                  A 1502, Greenfields Colony, Gate No 3, Faridabad, Haryana 121010
                </a>
              </p>

              {/* Phone Link */}
              <p>
                <PhoneOutlined />{" "}
                <a 
                  href="tel:+919266134138" 
                  style={linkStyle}
                  onMouseOver={(e) => e.target.style.color = "#d4af37"}
                  onMouseOut={(e) => e.target.style.color = "inherit"}
                >
                  +91 9266134138
                </a>
              </p>

              {/* Email Link */}
              <p>
                <MailOutlined />{" "}
                <a 
                  href="mailto:info@miransuites.com" 
                  style={linkStyle}
                  onMouseOver={(e) => e.target.style.color = "#d4af37"}
                  onMouseOut={(e) => e.target.style.color = "inherit"}
                >
                  info@miransuites.com
                </a>
              </p>
            </div>

            {/* Google Map */}
            <div
              style={{
                marginTop: "2rem",
                height: "350px",
                width: "100%",
                borderRadius: "8px",
                overflow: "hidden",
                boxShadow: "0 4px 12px rgba(0,0,0,0.1)"
              }}
            >
              <iframe 
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3507.57331478823!2d77.3005958!3d28.462276100000004!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x390ce76526e7e797%3A0x5048b3f3348cbd23!2sMiran%20Hotel%20%26%20Suites%20-%20Mathura%20Road%20Faridabad!5e0!3m2!1sen!2sin!4v1768393793653!5m2!1sen!2sin" 
                width="100%" 
                height="100%" 
                style={{ border: 0 }} 
                allowFullScreen="" 
                loading="lazy" 
                referrerPolicy="no-referrer-when-downgrade"
                title="Miran Suites Location"
              ></iframe>
            </div>
          </Col>

          <Col xs={24} md={12}>
            <Form layout="vertical" size="large">
              <Form.Item name="name" label="Name" rules={[{ required: true }]}>
                <Input placeholder="Your Name" />
              </Form.Item>
              <Form.Item
                name="email"
                label="Email"
                rules={[{ required: true, type: "email" }]}
              >
                <Input placeholder="Your Email" />
              </Form.Item>
              <Form.Item
                name="message"
                label="Message"
                rules={[{ required: true }]}
              >
                <TextArea rows={6} placeholder="How can we help you?" />
              </Form.Item>
              <Button
                type="primary"
                htmlType="submit"
                block
                style={{ background: "#1a1a1a", height: "50px" }}
              >
                Send Message
              </Button>
            </Form>
          </Col>
        </Row>
      </div>
    </PageFade>
  );
};

export default Contact;